export const AI_CREDITS_DAILY_LIMIT = 10;
export const AI_CREDITS_STORAGE_KEY = "ai_daily_credits";
export const AI_CREDITS_CLOSE_TO_LIMIT_DISMISSED_KEY = "ai_credits_close_to_limit_dismissed_date";
export const AI_CREDITS_EXCEEDED_DISMISSED_KEY = "ai_credits_exceeded_dismissed_date";
